// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { BrandDescription, BrandNames } from 'sharedEnums/brand-names';
import { Environment } from 'sharedModels/environment';
import { baseEnvironment } from 'sharedEnvironment/baseEnvironment';

export const brandEnvironment: Environment = {
    ...baseEnvironment,
    brand: BrandNames.VIRSEKER,
    brandDescription: BrandDescription.VIRSEKER,
    brandSiteUrl: 'https://www.virseker.co.za/',
    brandDashboardLoginUrl: 'https://policy.virseker.co.za/',
    gtmId: 'GTM-TSCD796',
    globalErrorMessage: `O gits! Iets het verkeerd geloop. Jammer vir die ongerief, probeer asseblief later weer.`,
    globalErrorDialogTitle: 'Hier is fout',
    globalErrorCallbackText: 'Bel my terug',
    globalErrorRetryText: 'Probeer weer',
    globalErrorRetryMessage: `Dit lyk asof jou versoek langer as gewoonlik vat om te laai. Probeer asseblief weer of vra dat ons jou terugbel.`,
    globalErrorRetryTitle: `Dit vat 'n rukkie...`,
    enableSsrAbTesting: 'true',
    webtrendsLookupUrl: 'https://virseker-confusion-web-dev.isservices.co.za',
    webtrendsProjectAlias: 'ta_Virseker-UpfrontIDnumber',
    webtrendsMode: 'staging',
    defaultBaseRoute: '',
};
